import { render, staticRenderFns } from "./CustomerFilter.component.pug?vue&type=template&id=45c554e3&scoped=true&lang=pug&"
import script from "./CustomerFilter.component.ts?vue&type=script&lang=ts&"
export * from "./CustomerFilter.component.ts?vue&type=script&lang=ts&"
import style0 from "./CustomerFilter.component.scss?vue&type=style&index=0&id=45c554e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c554e3",
  null
  
)

export default component.exports